/* Tysk katalog for locale-inbox-vouchers-no.js (del 2 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'inbox.inboxWithCount': 'Posteingang ({count})',
  'inbox.wordDocuments': 'Dokumente',
  'inbox.wordVouchers': 'Belege',
  'inbox.emptyDocsTitle': 'Keine Dokumente',
  'inbox.emptyTrashTitle': 'Der Papierkorb ist leer',
  'inbox.emptyDocsText': 'Lade hier Vereinbarungen, Verträge und Dokumente hoch.',
  'inbox.searchDocsFull': 'Dokumente durchsuchen - Dateiname, Typ...',
  'inbox.vehicleCostReminderDefault': 'Nur wenn das Unternehmen ein Fahrzeug besitzt oder least.',
});
